import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const GiftFinder = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Gift categories with slugs for API calls
    const giftCategories = [
        {
            title: "Gifts for Gamers",
            description: "Perfect for gaming enthusiasts",
            slug: "gamers", // NEW: API slug
            image: "/images/Mugs/Mario/pp6349nn_super_mario_warp_pipe_travel_mug_square_lifestyle_1.jpg"
        },
        {
            title: "Gifts for Movie Buffs",
            description: "For cinema lovers",
            slug: "movie-buffs",
            image: "/images/Poster/Jaws.jpg"
        },
        {
            title: "Gifts for TV Fans",
            description: "Binge-worthy presents",
            slug: "tv-fans",
            image: "/images/Poster/RickMorty3.jpg"
        },
        {
            title: "Gifts for a Superhero",
            description: "Heroic gift ideas",
            slug: "superhero",
            image: "/images/Lamps/Batman/batlight3.jpg"
        },
        {
            title: "Gifts for Kids",
            description: "Fun for the kids of all ages!",
            slug: "kids",
            image: "/images/Toys/SonicStretch/mini-stretch-sonic-the-hedgehog-wholesale-67015.jpg"
        },
        {
            title: "Gifts for Dad",
            description: "Perfect for Father's Day",
            slug: "dad",
            image: "/images/Homeware/Thor/thor2.jpg"
        },
        {
            title: "Gifts for Retro Lovers",
            description: "Nostalgic classics",
            slug: "retro-lovers",
            image: "/images/Collectables/Heman/heman/heman4.jpg"
        },
        {
            title: "Under £20",
            description: "Budget-friendly finds",
            link: "/search?maxPrice=20", // Keep existing price filter
            image: "/images/Mugs/Wolverine/pp13027xm_x-men_wolverine_shaped_mug_lifestyle_4_square.jpg"
        }
    ];

    const handleCategoryClick = (category) => {
        if (category.link) {
            // Price filter - use existing search page
            navigate(category.link);
        } else if (category.slug) {
            // Gift category - use new gift page
            navigate(`/gifts/${category.slug}`);
        }
    };

    // Reusable gift card component with image background
    const GiftCard = ({ category }) => (
        <div
            onClick={() => handleCategoryClick(category)}
            style={{
                position: 'relative',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                height: '280px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                margin: isMobile ? '0 0.5rem' : '0',
                border: '2px solid #3E6D9C',  // ADD THIS
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.25)';
                e.currentTarget.style.borderColor = '#FD7014';  // ADD THIS
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.15)';
                e.currentTarget.style.borderColor = '#3E6D9C';  // ADD THIS
            }}
        >
            {/* Background Image */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(${category.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                transition: 'transform 0.5s ease'
            }}
                 onMouseEnter={(e) => {
                     e.currentTarget.style.transform = 'scale(1.1)';
                 }}
                 onMouseLeave={(e) => {
                     e.currentTarget.style.transform = 'scale(1)';
                 }}
            />

            {/* Dark Overlay */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 60%, transparent 100%)',
                zIndex: 1
            }} />

            {/* Content */}
            <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '1.5rem',
                zIndex: 2,
                color: 'white',
                textAlign: 'left'
            }}>
                <h3 style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    marginBottom: '0.5rem',
                    textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                    color: 'white',
                }}>
                    {category.title}
                </h3>
                <p style={{
                    fontSize: '0.95rem',
                    margin: 0,
                    opacity: 0.95,
                    textShadow: '0 1px 4px rgba(0,0,0,0.5)',
                    color: 'white',
                }}>
                    {category.description}
                </p>
            </div>

            {/* Arrow indicator */}
            <div style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.2rem',
                color: 'white',
                zIndex: 2,
                transition: 'all 0.3s ease'
            }}
                 onMouseEnter={(e) => {
                     e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                     e.currentTarget.style.transform = 'translateX(4px)';
                 }}
                 onMouseLeave={(e) => {
                     e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                     e.currentTarget.style.transform = 'translateX(0)';
                 }}
            >
                →
            </div>
        </div>
    );

    return (
        <section style={{
            padding: '0rem 0',
            background: 'linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)'
        }}>
            <style>{`
                .gift-finder-mobile {
                    margin: 0 -1rem;
                    overflow: hidden;
                }

                .gift-finder-scroll {
                    display: flex;
                    overflow-x: auto;
                    scroll-snap-type: x mandatory;
                    -webkit-overflow-scrolling: touch;
                    scrollbar-width: none;
                    padding: 0 1rem;
                    gap: 1rem;
                    padding-bottom: 1rem;
                }

                .gift-finder-scroll::-webkit-scrollbar {
                    display: none;
                }

                .gift-finder-item {
                    flex: 0 0 85%;
                    max-width: 85%;
                    scroll-snap-align: center;
                }
            `}</style>
            <Container>
                {/* Section Header */}
                <div className="spotlight-section-header" style={{ marginBottom: '3.5rem' }}>
                    <div className="spotlight-header-badge" style={{ fontSize: '3.5rem' }}>
                        {/*🎁*/}
                    </div>
                    <div>
                        <h2 className="spotlight-section-title" style={{ marginBottom: '0.75rem' }}>
                            Find the Perfect Gift
                        </h2>
                        <p className="spotlight-section-subtitle" style={{ margin: 0 }}>
                            Not sure what to buy? We've got you covered!
                        </p>
                    </div>
                </div>

                {/* Gift Category Grid/Carousel */}
                {isMobile ? (
                    // Mobile: Horizontal scroll
                    <div className="gift-finder-mobile">
                        <div className="gift-finder-scroll">
                            {giftCategories.map((category, index) => (
                                <div key={index} className="gift-finder-item">
                                    <GiftCard category={category} />
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    // Desktop: Grid layout
                    <Row>
                        {giftCategories.map((category, index) => (
                            <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                                <GiftCard category={category} />
                            </Col>
                        ))}
                    </Row>
                )}

                {/* Browse All Link */}
                <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
                    <button
                        onClick={() => navigate('/search/')}
                        style={{
                            background: 'transparent',
                            border: '2px solid #3E6D9C',
                            color: '#3E6D9C',
                            padding: '1rem 3rem',
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            borderRadius: '25px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#3E6D9C';
                            e.target.style.color = 'white';
                            e.target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'transparent';
                            e.target.style.color = '#3E6D9C';
                            e.target.style.transform = 'translateY(0)';
                        }}
                    >
                        Browse All Products
                    </button>
                </div>
            </Container>
        </section>
    );
};

export default GiftFinder;